module.exports = __webpack_public_path__ + "img/mobileapp.08f1a1a1.svg";